import React from "react";
import classnames from "classnames";
import LanguageSelect from "~/components/inputs/LanguageSelect";
import styles from "./digitalReturns/DigitalReturnApp.module.scss";
import IngridLogo from "~/components/ingridLogo/IngridLogo";
import { getEnabledLanguages, showIngridLogo } from "~/cores/brandDataCore";
import { LANGUAGE_OPTIONS } from "~/constants";
import { isAppInIframe, isAppInitiatedWithQueryLanguage } from "~/cores/appCore";

export default function IngridFooter(props) {
    const { appProps, showDivider = true } = props;
    const { language, setLanguage } = appProps;

    const enabledLanguages = getEnabledLanguages(appProps).sort((l1, l2) => {
        const label1 = LANGUAGE_OPTIONS.find((lo) => lo.value === l1).label;
        const label2 = LANGUAGE_OPTIONS.find((lo) => lo.value === l2).label;
        if (label1 < label2) {
            return -1;
        }
        if (label2 < label1) {
            return 1;
        }
        return 0;
    });

    const showLogo = showIngridLogo(appProps);

    const showLanguages = enabledLanguages.length > 1 && (!isAppInIframe(appProps) || !isAppInitiatedWithQueryLanguage(appProps));

    return showLogo || showLanguages ? (
        <div style={{ marginTop: "20px" }}>
            {/*<div style={{ border: "1px solid black" }}></div>*/}
            <div
                style={{
                    borderTop: showDivider && "1px solid rgb(230, 230, 230)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: showDivider && "12px 0px 0px",
                }}
            >
                {showLanguages ? <LanguageSelect appProps={appProps} value={language} onChange={setLanguage} /> : <div />}
                {showLogo && (
                    <div className={classnames(styles["ingrid-logo-wrapper"])}>
                        <IngridLogo />
                    </div>
                )}
            </div>
        </div>
    ) : null;
}
